import { css } from '@wrisk/styled-system'
import { createGlobalStyle } from 'styled-components'

import defaults from './defaults'
import normalise from './normalise'

export const GlobalStyle = createGlobalStyle`
  ${normalise};
  ${defaults};
  ${(props) => props.theme.fontFaces ?? {}};
  ${(props) => css(props.theme.global ?? {})};
`
